import ForgotPasswordView from './forgot-password-view';

export default ForgotPasswordView;
